export const certificateItem = certificateCode => {
  let certificateName = "";
  switch (certificateCode) {
    case "0":
      certificateName = "居民身份证";
      break;
    case "1":
      certificateName = "护照";
      break;
    case "8":
      certificateName = "企业营业执照";
      break;
    case "B":
      certificateName = "港澳居民往来内地通行证";
      break;
    case "C":
      certificateName = "台湾居民来往大陆通行证";
      break;
    case "H":
      certificateName = "事业单位法人证书";
      break;
    case "J":
      certificateName = "社会团体登记证书";
      break;
    case "N":
      certificateName = "企业统一社会信用代码";
      break;
    case "Z":
      certificateName = "其它";
      break;
  }
  return certificateName;
};
export const approverItem = approverResult => {
  let approverName = "";
  switch (approverResult) {
    case "01":
      approverName = "待审批";
      break;
    case "02":
      approverName = "审批通过";
      break;
    case "03":
      approverName = "审批退回";
      break;
    case "04":
      approverName = "注册成功";
      break;
    case "05":
      approverName = "注册失败";
      break;
  }

  return approverName;
}



// WEBPACK FOOTER //
// ./src/filter/filters.js